import React from 'react';
import { formatLocalDateTime } from '../../utils/dates';
import Feedback from './Feedback';
import { MarkdownText } from '../../components/base/MarkdownText';
export var SenderEnum;
(function (SenderEnum) {
    SenderEnum["user"] = "user";
    SenderEnum["system"] = "system";
    SenderEnum["agent"] = "agent";
    SenderEnum["assistant"] = "assistant";
    SenderEnum["bot"] = "bot";
})(SenderEnum || (SenderEnum = {}));
export const Message = ({ message }) => {
    const { text, sender, feedback, onFeedback, timestamp, agent_name } = message;
    const showMetadata = message.showMessageMetadata || [];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { ...styles.message, ...styles[sender] } },
            typeof text === 'string' ? React.createElement(MarkdownText, { markdownText: text, style: { ...styles[sender] } }) : text,
            React.createElement("div", { className: "flex-row", style: { gap: 5, ...styles.sender } },
                showMetadata.includes('sender') && React.createElement("div", null, sender),
                showMetadata.includes('agent_name') && React.createElement("div", null,
                    "- ",
                    agent_name),
                showMetadata.includes('timestamp') && React.createElement("div", null, formatLocalDateTime(timestamp)))),
        onFeedback && React.createElement(Feedback, { value: feedback, onFeedback: onFeedback })));
};
const styles = {
    message: {
        maxWidth: '70%',
        minWidth: '50%',
        margin: '10px 0',
        padding: '10px',
        borderRadius: '10px',
        fontSize: '14px',
    },
    sender: {
        fontSize: '12px',
    },
    user: {
        alignSelf: 'flex-end',
        backgroundColor: '#0084ff',
        color: '#FFF',
    },
    system: {
        alignSelf: 'flex-start',
        backgroundColor: 'rgb(170, 230, 170)',
        color: '#000',
    },
    agent: {
        alignSelf: 'flex-start',
        backgroundColor: 'rgb(117, 30, 204)',
        color: '#FFF',
    },
    assistant: {
        alignSelf: 'flex-start',
        backgroundColor: 'rgb(255, 153, 51)',
        color: '#000',
    },
    bot: {
        alignSelf: 'flex-start',
        backgroundColor: '#e5e5ea',
        color: '#000',
    },
};
export default Message;
